import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Company } from "../../../models/Company";
import { useEffect, useState } from "react";
import { PolicyType } from "../../../models/PolicyType";
import CompanyService from "../../../services/company.service";
import PolicyTypeService from "../../../services/policyType.service";
import { Audit } from "../../../models/Audit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faSave } from "@fortawesome/free-solid-svg-icons";

type Props = {
  onHide: () => void;
  onSave: (newQuestionary: Audit) => void;
  userId: number;
  show: boolean;
};

export const ModalNewAudit = (props: Props) => {
  const [validated, setValidated] = useState(false);
  const [companies, setCompanies] = useState<Company[]>([]);
  const [poilicyTypes, setPolicyTypes] = useState<PolicyType[]>([]);
  const [questionary, setQuestionary] = useState<Audit>({
    companyId: -1,
    policyNumber: "",
    isCompleted: false,
    policyTypeId: -1,
  });

  function handlePolicyTypeChange(e: any) {
    setQuestionary({
      ...questionary,
      policyTypeId: e.target.value,
    });
  }

  function handlePolicyNumberChange(e: any) {
    setQuestionary({
      ...questionary,
      policyNumber: e.target.value,
    });
  }

  function handleCompanyChange(e: any) {
    setQuestionary({
      ...questionary,
      companyId: e.target.value,
    });
  }

  const handleOnSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    questionary.userId = props.userId;
    props.onSave(questionary);
    setValidated(true);
  };

  useEffect(() => {
    async function loadData() {
      let companiesData = await CompanyService.getCompanies();
      let policyTypesData = await PolicyTypeService.getPoliciTypes();

      setCompanies(companiesData);
      setPolicyTypes(policyTypesData.filter((pt) => !pt.isArchived));
    }

    loadData();
  }, []);

  return (
    <Form validated={validated} noValidate>
      <Modal
        show={props.show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Nueva Auditoría
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Label>Compañía</Form.Label>
              <Form.Select
                aria-label="Default select example"
                onChange={handleCompanyChange}
                required={true}
              >
                <option>Seleccionar Compañía</option>
                {companies.map((f) => (
                  <option value={f.id}>{f.name}</option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label>Número de Póliza</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                onChange={handlePolicyNumberChange}
                required={true}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label>Tipo de Póliza</Form.Label>
              <Form.Select
                aria-label="Default select example"
                onChange={handlePolicyTypeChange}
                required={true}
              >
                <option>Seleccionar tipo de Poliza</option>
                {poilicyTypes
                  .filter((x) => x.isActive === true)
                  .map((f) => (
                    <option value={f.id}>{f.policyDesc}</option>
                  ))}
              </Form.Select>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide} variant="secondary">
            <FontAwesomeIcon icon={faBan} style={{ paddingRight: "3px" }} />
            <span className="ms-2">Cancelar</span>
          </Button>
          <Button type="submit" variant="primary" onClick={handleOnSubmit}>
            <FontAwesomeIcon
              icon={faSave}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Guardar</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </Form>
  );
};
